'use client';

import { IconFreeShipping } from '@/icons/IconFreeShipping';

interface FreeShippingInfoProps {
  show?: boolean;
  text?: string;
}

const FreeShippingInfo = ({ show, text = 'Available for this product.' }: FreeShippingInfoProps) => {
  if (!show) return null;

  return (
    <div className="flex pl-6 text-start text-lg">
      <div className="-ml-6 mr-2 min-w-[18px] text-center">
        <IconFreeShipping className="-mt-1 w-5" />
      </div>
      <div>
        <strong className="mb-2">Free Shipping: </strong> {text}
      </div>
    </div>
  );
};

export default FreeShippingInfo;